<template>
    <div class="dash-faq">
        <div class="row" v-if="faqEntries && faqEntries.length > 0">
            <div class="panel-group">
                <v-collapse-wrapper class="panel panel-default" v-for="faq in faqEntries" v-bind:key="faq.headline">
                    <div class="panel-heading" @click="switchIcon">
                        <span class="panel-title">
                            <a href="#faqs-entries" v-collapse-toggle>
                                <h3 class="no-margin">{{faq.faq_headline}}
                                    <i class="glyphicon glyphicon-plus"></i>
                                </h3>
                            </a>
                        </span>
                    </div>
                    <div class="panel-collapse" v-collapse-content>
                        <div class="panel-body"><span v-html="faq.faq_description"></span></div>
                    </div>
                </v-collapse-wrapper>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faq-accordion",
        props: ['faq-entries'],
        data: function () {
            return {
                currentItem: null
            }
        },
        methods: {
            switchIcon: function (e) {
                let icon = e.target;
                if(icon.children.length > 0){
                    icon = icon.children.item(0);
                }
                let curClass = icon.getAttribute("class");
                switch (curClass) {
                    case "glyphicon glyphicon-plus":
                        if (this.currentItem !== null) {
                            this.currentItem.setAttribute("class", "glyphicon glyphicon-plus");
                        }
                        icon.setAttribute("class", "glyphicon glyphicon-minus");
                        this.currentItem = icon;
                        break;
                    case "glyphicon glyphicon-minus":
                        icon.setAttribute("class", "glyphicon glyphicon-plus");
                        this.currentItem = icon;
                        break;
                }
            }
        }
    }
</script>

<style scoped>

h3 {
    font-weight: 400;
}
</style>
